import { createFileRoute } from '@tanstack/react-router';
import { ResidentTaxStatementProfileRegistryPage } from './-components/ResidentTaxStatementProfileRegistryPage';
export const Route = createFileRoute('/_staff/salary-and-wages-mock/_layout/settings/resident-tax-statements/')({
  component: ResidentTaxStatementProfileRegistryPage
});